
import config from '../views/login/config/remote_api';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  postLogin: (idGroup, idEmpresa, contrasenia, correo) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/login/`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa
      },
      data: {
        contrasenia: contrasenia,
        correo: correo
      },
      redirect: 'follow'
    })
  },
  getTermsConditions: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/termsnconditions/`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      redirect: 'follow'
    })
  },
  postTermsConditions: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/termsnconditions/accept`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      redirect: 'follow'
    })
  },
}


